export enum EStatusStyleType {
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING',
  DANGER = 'DANGER',
  NORMAL = 'NORMAL',
}
